import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import ForgetPwd from '../views/forgetPwd'
import Home from '../views/Home'
import FriendChat from '../views/chat/FriendChat'
import UserInfo from '../views/UserInfo'


// 测试用
import SellerPage from '../views/echarts/SellerPage.vue'  // 这里的@ 应该是绝对路径
// import TrendPage from '../views/echarts/TrendPage.vue'
// import MapPage from '../views/echarts/MapPage.vue'
// import RankPage from '../views/echarts/RankPage.vue'
// import HotPage from '../views/echarts/HotPage.vue'
// import StockPage from '../views/echarts/StockPage.vue'
// import ConsWorkplace from '../views/cons/ConsWorkplace.vue'

import ScreenPage from '../views/echarts/ScreenPage.vue'

Vue.use(VueRouter)


// 解决报错 ： Uncaught (in promise) Error: Navigation cancelled from "/" to "/home" with a new navigation.
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// // push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
	return originalReplace.call(this, location).catch(err => err)
}
// 解决报错 end


const routes = [{
	path: '/',
	name: 'Login',
	component: Login,
	hidden: true
},
{
	path: '/sellerpage',
	component: SellerPage
},
{
	path: '/forgetPwd',
	name: 'forgetPwd',
	component: ForgetPwd,
	hidden: true
},
// {
//     path: '/consworkplace',
//     component: ConsWorkplace
// },
// {
//     path: '/trendpage',
//     component: TrendPage
// },
// {
//     path: '/mappage',
//     component: MapPage
// },
// {
//     path: '/rankpage',
//     component: RankPage
// },
// {
//     path: '/hotpage',
//     component: HotPage
// },
// {
//     path: '/',
//     redirect: '/screen'
// },
{
	path: '/screen',
	component: ScreenPage
},
// {
//     path: '/stockpage',
//     component: StockPage
// },
{
	path: '/home',
	name: 'Home',
	component: Home,
	children: [
		{
			path: '/chat',
			name: '待办任务',
			component: FriendChat,
		},
		{
			path: '/userinfo',
			name: '个人中心',
			component: UserInfo,
		},
		{
			path: '/video/VideoChapter',
			name: '章节管理',
			component: () => import('../views/video/VideoChapter.vue'),
		},
		{
			path: '/video/VideoPlayer',
			name: '视频播放',
			component: () => import('../views/video/VideoPlayer.vue'),
		}
	]
},
]

const router = new VueRouter({
	routes
})

export default router
